import { css } from 'linaria';

export const kitchenDownloadCatalogBody = css`
  display: flex;
  align-items: center;
  padding: 24px;

  @media (--only-tablet) {
    padding: 20px 24px;
  }

  @media (--only-mobile) {
    padding: 20px 16px;
  }
`;

export const newDownloadCatalogCartBody = css`
  @media (--only-desktop) {
    padding-right: 0;
  }
`;

export const kitchenDownloadCatalogIcon = css`
  width: 20px;
  height: 20px;
`;

export const kitchenDownloadCatalogImage = css`
  width: 120px;
  height: 100%;
  margin-right: 16px;
  object-fit: contain;

  @media (--to-desktop) {
    width: 92px;
    height: 80px;
  }
`;

export const newKitchenDownloadCatalogCartImage = css`
  align-self: flex-end;
  width: 214px;
  height: auto;
  margin-right: 18px;
  object-fit: contain;

  @media (--only-desktop) {
    width: 146px;
    margin-right: 0;
  }

  @media (--only-tablet) {
    width: 116px;
    margin-right: 8px;
  }

  @media (--only-mobile) {
    width: 100px;
    margin-right: 6px;
  }
`;

export const kitchenDownloadCatalogText = css`
  && {
    padding-left: 12px;
    && {
      line-height: 28px;
      color: var(--text-primary);

      @media (--to-desktop) {
        font-size: 14px;
        line-height: 20px;
      }
    }
  }
`;

export const newDownloadCatalogCartText = css`
  && {
    @media (--to-desktop) {
      width: 120px;
      font-size: 16px;
      line-height: 24px;
    }
  }
`;
